import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_PATH } from '@/services'

export const useDeleteBookingRepair = (tokenId, config = {}) => {
  const api = useLegacyPublicApi()
  const { formatMessage } = useIntl()
  const [errorMessage, setErrorMessage] = useState(null)

  const { mutateAsync: mutate, isLoading } = useMutation({
    mutationFn: async (request) => {
      if (!api || !tokenId) {
        return false
      }

      const { data: responseData } = await api.delete(
        SERVICE_BOOKING_PATH.replace('{tokenId}', tokenId),
        {
          data: {
            cancelReasonText: request.cancelReasonText,
            cancelReason: request.cancelReason,
          },
        },
      )
      return responseData
    },
    onError: (error) => {
      if (error)
        setErrorMessage(
          formatMessage({ id: 'page.bookingWizard.cancel-error' }),
        )
    },
    ...config,
  })
  const deleteBookingRepairTokenData = (cancelReasonText, cancelReason) =>
    mutate({ cancelReasonText, cancelReason })
  return { deleteBookingRepairTokenData, isLoading, errorMessage }
}

export default useDeleteBookingRepair
